// extracted by mini-css-extract-plugin
export var addButton = "_gc-0";
export var border = "_gc-8";
export var check = "_gc-h";
export var danger = "_gc-6";
export var dropdownContainer = "_gc-1";
export var editModalBody = "_gc-j";
export var footerContainer = "_gc-i";
export var fullWidth = "_gc-a";
export var hide = "_gc-9";
export var icon = "_gc-3";
export var input = "_gc-7";
export var inputFlex = "_gc-b";
export var inputWrapper = "_gc-c";
export var manualFocus = "_gc-5";
export var optionButton = "_gc-4";
export var pillWrapper = "_gc-e";
export var pointer = "_gc-2";
export var showOverflow = "_gc-f";
export var tagsFlex = "_gc-d";
export var xButton = "_gc-g";